<div class="background">
  <div class=" red-background">
    <mat-list class="reset-list">
      <br>
      <br>

      <mat-list-item class="centralizing">
        <img src="../../../../../assets/images/logoEstiWhite.svg" height="50px" class="esty-logo-padding">
      </mat-list-item>
      @if (tenantLogoUrl) {
      <mat-list-item class="centralizing mapfre-logo-row">
        <img [src]="tenantLogoUrl" height="30px" alt="Tenant logo">
      </mat-list-item>
      }

      <br>
      <br>
      <br>
      <br>


      <h4 class="lightColor">{{variables.resetPassword}}</h4>

      <br>
      <br>

      <form [formGroup]="resetPassForm" (keydown.enter)="onSubmit()">

        <!-- <mat-list-item>
          <mat-form-field class="form-field fullInputField" appearance="outline">
            <input matInput placeholder="Password" value="" type="password" formControlName="passwordCtrl">

          </mat-form-field>
        </mat-list-item> -->

        <mat-list-item class="field-row">
          <mat-form-field appearance="fill" class="form-field fullInputField input-field">
            <mat-label>Password</mat-label>
            <input matInput formControlName="passwordCtrl" type="password">
          </mat-form-field>
        </mat-list-item>

        <br>
        <br>
        <br>

        <!-- <mat-list-item>
          <mat-form-field class="form-field fullInputField" appearance="outline">
            <input matInput placeholder="Password" value="" type="password" formControlName="secondPasswordCtrl">
            <mat-error>
              <span **ngIf="resetPassForm.errors?.required">{{variables.passRequired}}</span>
            </mat-error>
          </mat-form-field>
        </mat-list-item> -->

        <mat-list-item class="form-field fullInputField field-row">
          <mat-form-field appearance="fill" class="form-field fullInputField input-field">
            <mat-label>Password</mat-label>
            <input matInput formControlName="secondPasswordCtrl" type="password">
            <mat-error>
              <span **ngIf="resetPassForm.errors?.required">{{variables.passRequired}}</span>
            </mat-error>
          </mat-form-field>
        </mat-list-item>


        <mat-list-item>
          @if (resetPassForm.errors?.mismatch) {
          <mat-hint class="mat-error"> {{variables.passwordsDontMatch}}
          </mat-hint>
          }

          @if (invalidPass) {
          <mat-hint class="mat-error">{{variables.passSizeInvalid}}</mat-hint>
          }
        </mat-list-item>

        <br>
        <br>


        <!-- <mat-list-item>
          <div class="centralizing">
            <app-button typeBtn="secondary" (click)="onSubmit()" class="mr-1" message="Redefinir">
            </app-button>
          </div>
        </mat-list-item> -->

        <mat-list-item class="centralizing btn-margin button-row">
          <div class="button-wrap">
            <app-button typeBtn="secondary" [width]="'fit-content'" (click)="onSubmit()" message={{variables.redefine}}>
            </app-button>
          </div>
        </mat-list-item>
      </form>
    </mat-list>
  </div>
</div>